import { render, staticRenderFns } from "./CustomConfig.vue?vue&type=template&id=3506f1a3&"
import script from "./CustomConfig.vue?vue&type=script&lang=js&"
export * from "./CustomConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports